import { Link, useLocation, useParams } from "react-router-dom";
import LoaderLayout from "../../../../components/Layout/LoaderLayout";
import UserInfoInMedicalReports from "../../../../components/Reports/MedicalReports/UserInfoInMedicalReports";
import useQueryFetch from "../../../../hooks/useQueryFetch";
import request from "../../../../utils/request";
import { useContext, useEffect, useMemo, useState } from "react";
import { UserContext } from "../../../../Context/UserContextAPI";
import VaccineEntryForm from "./VaccineEntryForm";
import { Button, Col, Row } from "react-bootstrap";

const MedicalVaccineEntry = () => {
  const { userId } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryData = queryParams.get("data") || 3;

  // states
  const [vaccineReportData, setVaccineReportData] = useState([]);

  const { settingsData, accessPerm } = useContext(UserContext);

  // user detail data fetch
  const { data: userDetailData, isLoading } = useQueryFetch(
    ["user", userId],
    () => request.getOne("user-details/test", userId)
  );
  const userDetail = userDetailData?.userDetail;

  // investigations data fetch
  const { data: investigations, isSuccess: isInvestigationsSuccess } =
    useQueryFetch(
      ["investigations", queryData, { role_id: userDetail?.user?.role_id }],
      async () => {
        const res = await request.create(`reports/get-data/${queryData}`, {
          invIds:
            userDetail?.user?.role_id === 5
              ? userDetail?.investigation_id?.split(",")
              : userDetail?.package?.investigation_id?.split(",") || [],
        });
        return res.status === "OK" ? res.data : [];
      },
      {
        placeholderData: [],
      }
    );

  // vaccine tests data fetch
  const { data: vaccineTests } = useQueryFetch(["vaccineTests", userId], () =>
    request.getOne("reports/vaccine", userId)
  );
  console.log("vaccineTests", vaccineTests);

  // split investigation in two, if event , one side will be more then 1
  const splitInvestigation = useMemo(() => {
    const firstHalf = investigations?.slice(
      0,
      Math.ceil(investigations.length / 2)
    );
    const secondHalf = investigations?.slice(
      Math.ceil(investigations?.length / 2)
    );
    return { firstHalf, secondHalf };
  }, [investigations]);

  const { firstHalf, secondHalf } = splitInvestigation;

  const handleNormalValue = () => {
    investigations?.forEach((investigation, index) => {
      //   setChangeColor("text-dark");
      setVaccineReportData((previousReport) => {
        const updatedReport = previousReport.map((report) => {
          if (report?.test_id === investigation?.investigation_tests[0]?.id) {
            if (investigation?.investigation_tests[0]?.info) {
              return {
                ...report,
                result: investigation?.investigation_tests[0]?.info?.replace(
                  /<[^>]*>/g,
                  ""
                ),
              };
            }
          }
          return report;
        });
        return updatedReport;
      });
    });
  };

  useEffect(() => {
    // if (!userId || !vaccineTests?.length || !investigations?.length) return;

    // setVaccineReportData([]);
    if (vaccineTests?.length > 0) {
      const initialData = investigations?.map((investigation) => {
        // Find matching pathologyTest for the current investigation
        const matchedTest = vaccineTests?.find(
          (test) => test.investigation_id === investigation.id
        );
        // Determine the result and test_id based on matchedTest or default to the first investigation_test
        const result =
          matchedTest?.result?.replace(/<[^>]*>/g, "") || matchedTest?.result;
        const test_id = matchedTest
          ? matchedTest.test_id
          : investigation.investigation_tests[0]?.id;

        return {
          user_id: userId,
          investigation_id: investigation.id,
          test_id: test_id,
          user_file: matchedTest ? matchedTest.user_file : "",
          result: result,
          riskFactor: "",
        };
      });
      console.log("initialData", initialData);
      setVaccineReportData(initialData);
    } else {
      // If no fetched values, initialize pathologyReportData based on investigations
      const initialData = investigations?.map((investigation) => ({
        user_id: userId,
        investigation_id: investigation.id,
        test_id: investigation.investigation_tests[0].id,
        user_file: "",
        result: "",
        riskFactor: "",
      }));
      setVaccineReportData(initialData);
    }
  }, [userId, vaccineTests, investigations]);

  console.log(vaccineReportData);

  const saveVaccineReport = async () => {
    try {
      const response = await request.updateOne(
        `reports/save/vaccine/data/all`,
        userId,
        { vaccineReportData }
      );
      console.log("response", response);
      if (response?.status === "OK") {
        await request.getOne(`reports/user-test-status`, userId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <LoaderLayout isPending={isLoading}>
      <div className="card p-3 medical-report">
        <div className="row mb-2 bg-primary text-white px-2 py-2">
          <h6 className="mb-0">
            Medical Vaccine Report for {userDetail?.user?.f_name}{" "}
            {userDetail?.user?.l_name} [{userDetail?.user?.reg_prefix || ""}
            {userDetail?.user?.registration_no}]
          </h6>
        </div>

        {/* user table info */}
        <div className="row justify-content-center h-100">
          {userDetail && (
            <UserInfoInMedicalReports
              userDetail={userDetail}
              settingsData={settingsData}
            />
          )}
        </div>
        <div className="mt-4">
          <Row>
            <Col md={6}>
              <div className="pe-2">
                <VaccineEntryForm
                  investigations={firstHalf}
                  vaccineReportData={vaccineReportData}
                  setVaccineReportData={setVaccineReportData}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="ps-2">
                <VaccineEntryForm
                  investigations={secondHalf}
                  vaccineReportData={vaccineReportData}
                  setVaccineReportData={setVaccineReportData}
                />
              </div>
            </Col>
          </Row>
        </div>

        <Row className="mt-4">
          <Col md={6}>
            <div className="d-flex gap-2">
              {userDetailData?.nextPage && accessPerm(33, 31) && (
                <Link
                  to={`/dashboard/medical-reports/vaccine/create/${userDetailData?.nextPage}?data=4`}
                  className="btn btn-primary"
                >
                  Previous
                </Link>
              )}
              {userDetailData?.previousPage && accessPerm(33, 31) && (
                <Link
                  to={`/dashboard/medical-reports/vaccine/create/${userDetailData?.previousPage}?data=4`}
                  className="btn btn-primary"
                >
                  Next
                </Link>
              )}
            </div>
          </Col>
          <Col md={6}>
            <div className="mt-4 d-flex justify-content-end gap-2">
              {accessPerm(33, 30) && (
                <Button variant="outline-primary" onClick={handleNormalValue}>
                  Set Normal
                </Button>
              )}
              {accessPerm(33, 30) && (
                <Button variant="primary" onClick={saveVaccineReport}>
                  Save
                </Button>
              )}
              <Button variant="secondary" onClick={() => window.close()}>
                Close
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </LoaderLayout>
  );
};
export default MedicalVaccineEntry;
